module.exports = __webpack_public_path__ + "static-appopensalud/img/self-test.435c017.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/icons/morillas-svg-icons/primary/self-test.svg
// module id = 3926
// module chunks = 76